//eslint-disable-next-line @typescript-eslint/no-explicit-any
export function hasToString(element: any): element is { toString(): string } {
  return element && typeof element.toString === 'function' && 'toString' in element;
}
